var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"border-comp3"},[_c('div',{staticClass:"comp3-content",style:({ backgroundColor: _vm.computedBg, border: '1px solid ' + _vm.computedBorder })},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }